module.exports = __webpack_public_path__ + "static/media/PDF.f79ec251.jpg";